import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LeapOptIn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
        }
    }

    render() {
        const checkboxSelectedClass = this.props.leapOptIn ? 'input__checkbox--selected' : '';
        return(
            <section className="checkout-form__section">
                <div className="form-card checkout-form__section__checkbox">
                    <div className={`form-card__content input__checkbox tos__checkbox ${checkboxSelectedClass}`}>
                        <div className="input input__checkbox-wrap" >
                            <div className="input__checkbox__input">
                                <input
                                    type="checkbox"
                                    name="leap_opt_in"
                                    id="leap_opt_in"
                                    onChange={this.props.onChangeLeapOptIn} 
                                    checked={this.props.leapOptIn}
                                />
                            </div>
                            <label htmlFor="leap_opt_in" className="input__checkbox__label">
                                {this.props.label}
                            </label>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

LeapOptIn.defaultProps = {
}

LeapOptIn.propTypes = {
    uiConfig: PropTypes.object, 
    onChangeLeapOptIn: PropTypes.func,
    leapOptIn: PropTypes.bool,
    label: PropTypes.object
};

export default LeapOptIn;